var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceTopUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2 {\n        opacity: .5;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #a3a3a2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.5,87h0ZM88.1,87h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.6,36l-8.5-8.8c-.2-.2-.4-.3-.6-.3h-37.6c-.5,0-.9.4-.9.9v64.4c0,.5.4.9.9.9h20.3v-1.8h-19.4V28.8h36.3l8,8.2v29.4h1.8v-29.8c0-.2,0-.5-.3-.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.5,33.5v4h1v-4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.5,33.5v2.3h0l-1.6-2.3h-.8v4h1v-2.3h0l1.6,2.3h.8v-4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.8,33.5l-.9,2.9h0l-.9-2.9h-1.1l1.3,4h1.3l1.3-4h-1.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.5,34.3c-.2-.3-.4-.5-.7-.7s-.6-.2-1-.2-.7,0-1,.2c-.3,0-.5.4-.7.7s-.2.7-.2,1.1,0,.8.2,1.1.4.5.7.7.6.2,1,.2.7,0,1-.2.5-.4.7-.7.2-.7.2-1.1,0-.8-.2-1.1ZM54.8,36.1c0,.2-.2.3-.3.4,0,0-.3,0-.5,0s-.4,0-.5,0c0,0-.2-.2-.3-.4,0-.2,0-.4,0-.7s0-.5,0-.7c0-.2.2-.3.3-.4,0,0,.3,0,.5,0s.4,0,.5,0c0,0,.2.2.3.4,0,.2,0,.4,0,.7s0,.5,0,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.4,33.5v4h1v-4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.5,36.3s0,0-.2.2c0,0,0,0-.2,0h-.3c-.2,0-.4,0-.5,0,0,0-.2-.2-.3-.4,0-.2,0-.4,0-.7s0-.5,0-.7c0-.2.2-.3.3-.4,0,0,.3,0,.5,0h.3s.2,0,.2,0l.2.2v.3h1c0-.2,0-.4-.2-.6,0-.2-.2-.3-.4-.5-.2,0-.3-.2-.5-.3h-.7c-.3,0-.7,0-.9.2-.3,0-.5.4-.7.7s-.2.7-.2,1.1,0,.8.2,1.1.4.5.7.7.6.2,1,.2.5,0,.7,0,.4-.2.5-.3.3-.3.4-.5c0-.2,0-.4,0-.5h-1v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.9,34.2v-.8h-2.8v4h2.8v-.8h-1.8v-.8h1.7v-.8h-1.7v-.8s1.8,0,1.8,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.5,
    y: 41.3,
    width: 17.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.9,
    y: 77.2,
    width: 17.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.5,
    y: 46.1,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.2,
    y: 82,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47,
    y: 56.2,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47,
    y: 65.5,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.3,
    y: 56,
    width: 4.1,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.3,
    y: 65.6,
    width: 4.1,
    height: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.5,51.6h-32.9c-.5,0-.9.4-.9.9v18.5c0,.5.4.9.9.9h23.6c.8-.7,2.2-1.8,2.2-1.8v-7.7h6.2v5.1c.6-.2,1.2-.3,1.8-.5v-14.6c0-.5-.4-.9-.9-.9h0ZM58.8,70.1h-14.3v-7.7h14.3v7.7ZM58.8,60.7h-14.3v-7.3h14.3v7.3ZM67.5,70.1h-7v-7.7h7v7.7ZM67.5,60.7h-7v-7.3h7v7.3ZM75.5,60.7h-6.2v-7.3h6.2v7.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63,
    y: 65.5,
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63,
    y: 56,
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.6,40.7v1.1h3c.5,0,.9.4.9.9v2.9c0,.5-.4.9-.9.9h-1.1v2.2h-1.8v-2.2h-2v-1.8h3.9v-1.1h-3c-.5,0-.9-.4-.9-.9v-3c0-.5.4-.9.9-.9h1.1v-2.2h1.8v2.2h2v1.9s-3.9,0-3.9,0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.5 109.2 88.5 109.2 88.5 103.4 82.9 103.4 82.9 101.6 88.5 101.6 88.5 95.8 90.5 95.8 90.5 101.6 96.1 101.6 96.1 103.4 90.5 103.4 90.5 109.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.5,76.1c-8,0-11.6,4.5-11.6,4.5v19.8l.2.2c0,.2,3,3.5,11,3.7h.9c0-.6-.2-1.3-.2-1.9,0-2.3.8-4.4,2.1-6.1-.2,0-2.9.3-3.9,0v-4.9h1.5c.9,0,1.8,0,2.7-.2v4.6c.5-.6,1.1-1.1,1.8-1.6v-3.3c1.7-.4,3.5-1,5.4-2v3.6h0c.5,0,1,0,1.5,0h0v-12.1h0s-3.6-4.4-11.6-4.4ZM69.5,82.1c.8.5,2,1.1,3.6,1.7v4.9c-1.8-.6-3-1.4-3.6-1.8,0,0,0-4.8,0-4.8ZM76.1,91.2v4.9c-1.1-.2-2.1-.5-3-.8v-4.9c.9.3,1.9.6,3,.7h0ZM69.5,89c.5.3,1.1.6,1.8.9v4.9c-.8-.4-1.4-.7-1.8-.9v-4.8h0ZM73.1,101.7c-2.1-.7-3.2-1.5-3.6-1.9v-3.9c.9.4,2.1,1,3.6,1.5v4.4h0ZM79,98.3v4.3c-1.5,0-2.9-.2-4-.4v-4.4c1.2.3,2.6.5,4,.5ZM79.1,89.8c-1.5,0-2.9-.2-4.1-.5v-5c1.2.3,2.6.4,4.1.5v5.1h0ZM70.4,80.5c1.2-.9,3.9-2.5,9-2.5s7.9,1.6,9.1,2.5c-1.4.9-4.4,2.4-9,2.4s-7.7-1.6-9.1-2.4ZM84.8,89c-1.3.4-2.6.6-3.8.7v-5.1c1.4,0,2.7-.3,3.8-.6v4.9h0ZM89.4,87c-1,.5-1.9,1-2.8,1.4v-4.9c1.2-.4,2.1-1,2.8-1.4v4.9Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceTopUp);
export default __webpack_public_path__ + "static/media/invoice-top-up.d6a15f4152f779f797f3d6712e471304.svg";
export { ForwardRef as ReactComponent };